<template>
  <div class="report">
    <div class="report-content">
      <filter-bar class="report-content-filter-bar" :itemArray="itemArray"
        :initialSelectedIndex="selectedComponentIndex" :keywordTitle="keywordTitle" :hasDatePicker="hasDatePicker" :initDuration="duration"
        :showModeType="showModeType" :modeType="modeType" v-model="keywords" @onItemSelected="onItemSelected" @onDurationSelected="onDurationSelected"
        @onSearchClick="onKeywordSearch" @onModeTypeChange="onModeTypeChange">
        <div class="export-buttons" v-if="selectedComponentIndex === 2">
          <button class="report-content-filter-bar-export-pdf" @click="onExportPdf">
            导 PDF
          </button>
          <button class="report-content-filter-bar-export" @click="onExportReport(selectedComponentIndex)">
            导出报告
          </button>
          <el-cascader
            v-model="cascadeValue"
            :options="schoolOptions"
            :props="{ 
              checkStrictly: false, 
              value: 'id', 
              label: 'name', 
              children: 'children',
              expandTrigger: 'hover'
            }"
            placeholder="请选择学校"
            clearable
            class="cascade-selector"
            @change="onCascadeChange"
          >
          </el-cascader>
          <el-select v-model="hasRingReport" placeholder="报告状态" clearable class="has-report-selector">
            <el-option label="有报告" :value="1"></el-option>
            <el-option label="无报告" :value="0"></el-option>
          </el-select>
          <button class="report-content-filter-bar-search" @click="onCascadeSearch">
            搜索
          </button>
        </div>
        <button v-else class="report-content-filter-bar-export" @click="onExportReport(selectedComponentIndex)">
          导出报告
        </button>
      </filter-bar>
      <component :is="currentComponent" ref="component" :componentDuration="componentDuration" :modeType="modeType"
        :schoolId="schoolId" :gradeId="gradeId" :classId="classId" :hasRingReport="hasRingReport">
      </component>
    </div>
  </div>
</template>

<script>
import FilterBar from "@c/operation-log/common/filter-bar/filter-bar.vue";
import SleepReport from "@c/report/sleep-report/sleep-report.vue";
import BloodOxygenReport from "@c/report/blood-oxygen-report/blood-oxygen-report.vue";
import LiangxiangReport from "@c/report/liangxiang-report/liangxiang-report.vue"
import { Cascader } from 'element-ui';

export default {
  components: {
    FilterBar,
    SleepReport,
    BloodOxygenReport,
    LiangxiangReport,
    ElCascader: Cascader
  },

  data: function () {
    return {
      // duration: [this.getTimestamp(7), this.getTimestamp(0, true)],
      duration: undefined,
      keywords: "",
      exportParams: undefined,
      selectedComponentIndex: 0,
      modeType: null,
      compoentArray: ["sleep-report", "blood-oxygen-report", "liangxiang-report"],
      cascadeValue: [],
      schoolOptions: [],
      schoolId: null,
      gradeId: null,
      classId: null,
      hasRingReport: undefined
    };
  },

  methods: {
    getTimestamp(daysAgo, endOfDay = false) {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0

      const targetDate = new Date(currentDate);
      targetDate.setDate(currentDate.getDate() - daysAgo);

      if (endOfDay) {
        targetDate.setHours(23, 59, 59, 999); // Set to end of the day
      }

      return Math.floor(targetDate.getTime()); // Convert to seconds
    },

    async fetchSchoolList() {
      if (this.isSanyaHospital) {
        this.schoolOptions = this.buildSanyaSchoolOptions();
        return;
      }
      try {
        const response = await fetch('https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/lx-school-list.json');
        const data = await response.json();
        this.schoolOptions = data;
      } catch (error) {
        console.error('Failed to fetch school list:', error);
      }
    },

    buildSanyaSchoolOptions() {
      const grades = ['一', '二', '三', '四', '五', '六'];
      const children = grades.map((gradeName, gradeIndex) => ({
        id: `sanya-grade-${gradeIndex + 1}`,
        name: gradeName+'年级',
        children: Array.from({ length: 6 }, (_, classIndex) => ({
          id: `sanya-grade-${gradeIndex + 1}-class-${classIndex + 1}`,
          name: `${gradeName}（${classIndex + 1}）班`
        }))
      }));
      children.push({
        id: 'sanya-special',
        name: '特教',
        children: Array.from({ length: 4 }, (_, classIndex) => ({
          id: `sanya-special-class-${classIndex + 1}`,
          name: `特教（${classIndex + 1}）班`
        }))
      });
      return [{
        id: 'sanya-school',
        name: '三亚某小学',
        children
      }];
    },

    onCascadeChange(value) {
      if (value && value.length > 0) {
        const schoolId = value[0];
        const gradeId = value[1];
        const classId = value[2];

        // Find school name
        const school = this.schoolOptions.find(s => s.id === schoolId);
        this.schoolId = school ? school.name : null;

        // Find grade name
        if (school && gradeId) {
          const grade = school.children.find(g => g.id === gradeId);
          this.gradeId = grade ? grade.name : null;

          // Find class name
          if (grade && classId) {
            const cls = grade.children.find(c => c.id === classId);
            this.classId = cls ? cls.name : null;
          } else {
            this.classId = null;
          }
        } else {
          this.gradeId = null;
          this.classId = null;
        }
      } else {
        this.schoolId = null;
        this.gradeId = null;
        this.classId = null;
      }
    },

    onCascadeSearch() {
      this.$nextTick(() => {
        if (this.$refs.component && this.$refs.component.onCascadeSearch) {
          this.$refs.component.onCascadeSearch({
            schoolName: this.schoolId,
            grade: this.gradeId,
            gradeName: this.classId
          });
        }
      });
    },

    onExportPdf() {
      this.$nextTick(() => {
        if (this.$refs.component && this.$refs.component.exportPdfBatch) {
          this.$refs.component.exportPdfBatch();
        }
      });
    },

    onItemSelected(index) {
      this.selectedComponentIndex = index;
      this.duration = undefined;
      this.keywords = undefined;
      this.cascadeValue = [];
      this.schoolId = null;
      this.gradeId = null;
      this.classId = null;
    },

    onExportReport(index) {
      let component = this.$refs.component;
      switch (index) {
        //导出睡眠报告
        case 0:
          const sleepReportParams = {
            modeType: this.modeType,
            exceptionClassifyIds: component.exceptionClassifyIds || []
          };
          component.exportReport(sleepReportParams)
          break;
        //导出睡眠初筛报告
        case 1:
          const bloodOxygenReportParams = {
            modeType: this.modeType
          };
          component.exportReport(bloodOxygenReportParams)
          break;
        case 2:
          component.exportReport({
            hospitalId: this.hospitalID == 0 ? null : this.hospitalID,
            keyword: this.keywords,
            schoolName: this.schoolId,
            grade: this.gradeId,
            gradeName: this.classId,
            hasRingReport: this.hasRingReport
          })
          break;
        default:
          break;
      }
    },

    onDurationSelected(duration) {
      this.duration = duration
    },

    onKeywordSearch(keyword) {
      this.$nextTick(() => { this.$refs.component.onSearchClick(keyword) })
    },

    onModeTypeChange(modeType) {
      this.modeType = modeType;
      this.$nextTick(() => { 
        if (this.$refs.component && this.$refs.component.onModeTypeChange) {
          this.$refs.component.onModeTypeChange(modeType);
        }
      });
    },

  },

  created() {
    this.fetchSchoolList();
  },

  watch: { 
    hospitalID(val, oldVal) {
      this.fetchSchoolList();
      if (!this.isAssessmentReportHospital && this.selectedComponentIndex == 2) {
        this.onItemSelected(0)
      }
    },
  },

  computed: {
    componentDuration() {
      if (this.duration) {
        return {
          startTime: this.duration[0] / 1000,
          endTime: this.duration[1] / 1000,
        };
      } else {
        return { startTime: null, endTime: null };
      }
    },

    hospitalID() { 
      return this.$store.state.selectedHospital.hospitalid
    },
    isAssessmentReportHospital() {
      return [515, 87].includes(this.hospitalID)
    },
    isSanyaHospital() {
      return this.hospitalID === 87
    },

    currentComponent() {
      return this.compoentArray[this.selectedComponentIndex]
    },
    itemArray() { 
      // 良乡、三亚医院多一个评估报告
      if (this.isAssessmentReportHospital) {
        return ['睡眠报告', '睡眠初筛报告', '评估报告']
      }
      return ['睡眠报告', '睡眠初筛报告']
    },
    showExport() {
      return true
    },
    keywordTitle() { 
      if (this.isAssessmentReportHospital && this.selectedComponentIndex == 2) {
        return '关键字'
      }
      return '姓名或设备SN'
    },
    hasDatePicker() { 
      if (this.isAssessmentReportHospital && this.selectedComponentIndex == 2) {
        return false
      }
      return true
    },
    showModeType() {
      return this.selectedComponentIndex !== 2;
    }
  },
};
</script>

<style lang="scss" scoped>
.report {
  background-color: #eff2f7;
  width: 100%;

  &-content {
    background-color: white;
    border-radius: rem(2);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-left: rem(36);
    padding-right: rem(33);
    display: flex;
    flex-direction: column;
    align-items: center;

    &-filter-bar {
      width: 100%;

      &-export, &-export-pdf {
        color: white;
        background: #325FAC;
        font-size: 14px;
        border-radius: 4px;
        width: 88px;
        height: 32px;
      }

      &-export {
        margin-left: 10px;
      }

      &-export-pdf {
        margin-left: 10px;
      }

      &-search {
        color: white;
        background: #325FAC;
        font-size: 14px;
        border-radius: 4px;
        width: 60px;
        height: 32px;
        margin-left: 10px;
      }
    }
  }
}

.export-buttons {
  display: flex;
  align-items: center;
}

.cascade-selector {
  margin-left: 10px;
  width: 310px;
}

.has-report-selector {
  margin-left: 10px;
  width: 120px;
}
</style>
